export const ENROLLEE_SAMPLE_HEADERS = [
  "firstname",
  "lastname",
  "middlename",
  "nimc_number",
  "email",
  "phone_number",
  "organization",
  "plan_type",
  "provider_id",
  "point_of_care",
  "localgovt",
  "ward",
  "dob",
  "expiry_date",
  "gender",
  "sector",
  "marital_status",
];

export const ENROLLEE_SAMPLE_ROW = [
  "JOHN",
  "DOE",
  "MICHAEL",
  "12345678901",
  "john.doe@example.com",
  "08030000000",
  "MINISTRY OF HEALTH",
  "Family",
  "",
  "",
  "",
  "",
  "1990-01-01",
  "2027-01-01",
  "Male",
  "Organized Private Sector",
  "Single",
];

function splitCsvLine(line) {
  const values = [];
  let current = "";
  let inQuotes = false;

  for (let index = 0; index < line.length; index++) {
    const char = line[index];
    const nextChar = line[index + 1];

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        current += '"';
        index++;
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === "," && !inQuotes) {
      values.push(current.trim());
      current = "";
    } else {
      current += char;
    }
  }

  values.push(current.trim());
  return values;
}

function normalizeCsvHeader(header) {
  return String(header || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_]/g, "");
}

export function parseCsvRows(csvText) {
  const lines = String(csvText || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => line.length > 0);

  if (!lines.length) {
    return [];
  }

  const headers = splitCsvLine(lines[0]).map((header) => normalizeCsvHeader(header));
  const rows = [];

  for (let index = 1; index < lines.length; index++) {
    const cols = splitCsvLine(lines[index]);
    const row = {};
    headers.forEach((header, colIndex) => {
      row[header] = cols[colIndex] !== undefined ? cols[colIndex] : "";
    });
    rows.push(row);
  }

  return rows;
}

export function getCsvValue(row, keys, fallback = "") {
  for (let index = 0; index < keys.length; index++) {
    const key = keys[index];
    if (row[key] !== undefined && row[key] !== null && String(row[key]).trim() !== "") {
      return String(row[key]).trim();
    }
  }
  return fallback;
}

export function buildSampleCsvText() {
  return `${ENROLLEE_SAMPLE_HEADERS.join(",")}\n${ENROLLEE_SAMPLE_ROW.join(",")}`;
}

export function mapCsvRowToPayload(row, { agencyId, enrolledBy }) {
  const firstname = getCsvValue(row, ["firstname"]);
  const lastname = getCsvValue(row, ["lastname"]);
  const organizationName = getCsvValue(row, ["organization"]);
  const email = getCsvValue(row, ["email"]);

  if (!firstname || !lastname || !organizationName) {
    return null;
  }

  return {
    firstname: firstname.toUpperCase(),
    lastname: lastname.toUpperCase(),
    middlename: getCsvValue(row, ["middlename"]).toUpperCase(),
    email: email,
    phone_number: getCsvValue(row, ["phone_number", "phone", "mobile"]),
    type: "client",
    agency_id: agencyId,
    enabled_user: 0,
    plan_type: getCsvValue(row, ["plan_type"], "Family"),
    nimc_number: getCsvValue(row, ["nimc_number"]),
    provider_id: getCsvValue(row, ["provider_id", "point_of_care"]),
    point_of_care: getCsvValue(row, ["point_of_care", "provider_id"]),
    localgovt: getCsvValue(row, ["localgovt", "lga"]),
    ward: getCsvValue(row, ["ward"]),
    blood: getCsvValue(row, ["blood", "blood_group"]),
    dob: getCsvValue(row, ["dob", "date_of_birth"]),
    expiry_date: getCsvValue(row, ["expiry_date"]),
    address1: getCsvValue(row, ["address1", "address"]),
    genotype: getCsvValue(row, ["genotype"]),
    gender: getCsvValue(row, ["gender"]),
    sector: getCsvValue(row, ["sector"], "Organized Private Sector"),
    place_of_work: organizationName,
    salary_number: getCsvValue(row, ["salary_number"]),
    grade_level: getCsvValue(row, ["grade_level"]),
    date_of_entry: getCsvValue(row, ["date_of_entry"]),
    marital_status: getCsvValue(row, ["marital_status"]),
    enrolled_by: enrolledBy,
  };
}
